import { useQuery, useMutation, keepPreviousData } from "@tanstack/react-query";
import qs from "qs";
import api from "@services/api";

async function fetchCoupons(filters, page, pageSize) {
  const query = qs.stringify(
    { ...filters, page, page_size: pageSize },
    { encodeValuesOnly: true }
  );
  const { data } = await api.get(`/coupon?${query}`);
  return data;
}

export function useCouponsQuery(filters, page, pageSize) {
  return useQuery({
    queryKey: ["marketing", "coupons", filters, page, pageSize],
    queryFn: () => fetchCoupons(filters, page, pageSize),
    placeholderData: keepPreviousData
  });
}

export function useCreateCouponMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post(`/coupon`, payload);
      return data;
    }
  });
}

export function useSaveCouponMutation() {
  return useMutation({
    mutationFn: async ({ id, payload }) => {
      const { data } = await api.post(`/coupon/${id}`, payload);
      return data;
    }
  });
}

export function useDeleteCouponMutation() {
  return useMutation({
    mutationFn: async (id) => {
      await api.delete(`/coupon/${id}`);
      return true;
    }
  });
}

export function useCouponOrdersQuery(couponId, page, pageSize) {
  return useQuery({
    queryKey: ["marketing", "coupon-orders", couponId, page, pageSize],
    queryFn: async () => {
      const query = qs.stringify(
        { page, page_size: pageSize },
        { encodeValuesOnly: true }
      );
      const { data } = await api.get(`/coupon/${couponId}/orders?${query}`);
      return data;
    },
    enabled: !!couponId,
    placeholderData: keepPreviousData
  });
}
